module.exports = __webpack_public_path__ + "static/media/biosense-03.af440c38.png";


//////////////////
// WEBPACK FOOTER
// ./src/css/img/popup/biosense-03.png
// module id = 2899
// module chunks = 3